
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 430.88 505.14"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M31.41 164.71h-1.3A30.2 30.2 0 000 194.83v131.1a30.18 30.18 0 0030.11 30.14h1.32a30.2 30.2 0 0030.11-30.14v-131.1a30.24 30.24 0 00-30.13-30.12zM76 376.54a27.71 27.71 0 0027.68 27.63h29.52V475a30.2 30.2 0 0030.11 30.15h1.3A30.2 30.2 0 00194.76 475v-70.83h41.33V475a30.24 30.24 0 0030.16 30.15h1.27A30.19 30.19 0 00297.66 475v-70.83h29.59a27.71 27.71 0 0027.66-27.63v-207H76zM284.91 44L308.4 7.72a5 5 0 00-1.47-6.9A5 5 0 00300 2.29L275.67 39.8a161 161 0 00-120.47 0L130.89 2.29a5 5 0 00-8.41 5.43L146 44c-42.4 20.76-71 59.91-71 104.82 0 2.76.18 5.48.41 8.17h280.08c.23-2.69.38-5.41.38-8.17.01-44.91-28.6-84.06-70.96-104.82zm-134.39 64.91A13.45 13.45 0 11164 95.45a13.46 13.46 0 01-13.48 13.46zm129.84 0a13.45 13.45 0 1113.46-13.46 13.46 13.46 0 01-13.46 13.46zM400.74 164.71h-1.25a30.24 30.24 0 00-30.16 30.12v131.1a30.23 30.23 0 0030.16 30.14h1.27a30.19 30.19 0 0030.12-30.14v-131.1a30.22 30.22 0 00-30.14-30.12z"}})])
          )
        }
      }
    